import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import CommercialApp from '../../../CommercialApp';
import HomeGate from '../pages/HomeGate';
import HomeLandingRoute from '../pages/HomeLandingRoute';
import CommercialLoginPage from '../pages/CommercialLoginPage';
import AuthCallback from '../pages/AuthCallback';
import PricingPage from '../pages/PricingPage';
import TosPage from '../pages/TosPage';
import RefundPage from '../pages/RefundPage';
import HelpPage from '../pages/HelpPage';
import PrivacyPolicyPage from '../PrivacyPolicyPage';
import RequireAuth from '../pages/RequireAuth';

// Legacy hash redirect: #/privacy → /privacy (one-time migration)
const LegacyHashRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === '#/privacy') {
      window.location.hash = '';
      navigate('/privacy', { replace: true });
    }
  }, [location.pathname, navigate]);
  return null;
};

const PrivacyPolicyRoute: React.FC = () => {
  const navigate = useNavigate();
  return <PrivacyPolicyPage onBack={() => navigate('/')} />;
};

const CommercialRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <LegacyHashRedirect />
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomeGate />} />
        <Route path="/home" element={<HomeLandingRoute />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyRoute />} />
        <Route path="/tos" element={<TosPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/login" element={<CommercialLoginPage />} />
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected app — /app/* all renders CommercialApp shell; inner sidebar modes sync via URL */}
        <Route
          path="/app/*"
          element={
            <RequireAuth>
              <CommercialApp />
            </RequireAuth>
          }
        />

        {/* Admin — same CommercialApp shell, sidebarMode=admin */}
        <Route
          path="/admin/*"
          element={
            <RequireAuth requireAdmin>
              <CommercialApp />
            </RequireAuth>
          }
        />

        {/* Unknown → home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default CommercialRouter;
